import React from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ rating, onChange, size = 'w-6 h-6', testIdPrefix = '' }) {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((value) => (
        <button
          key={value}
          onClick={() => onChange(value)}
          className="p-1"
          data-testid={testIdPrefix ? `${testIdPrefix}-star-${value}` : undefined}
        >
          <Star
            className={`${size} ${value <= rating ? 'fill-[hsl(var(--rating-gold))] text-[hsl(var(--rating-gold))]' : 'text-gray-300'}`}
          />
        </button>
      ))}
    </div>
  );
}
